module.exports = __webpack_public_path__ + "5d28ba9cdc83d23dc78192f1e47e39ac.png";